import { render, staticRenderFns } from "./RegistroCesantia.vue?vue&type=template&id=43e164dc&scoped=true"
import script from "./RegistroCesantia.vue?vue&type=script&lang=ts"
export * from "./RegistroCesantia.vue?vue&type=script&lang=ts"
import style0 from "./RegistroCesantia.vue?vue&type=style&index=0&id=43e164dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e164dc",
  null
  
)

export default component.exports